import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { AuthLayout } from '#components/patterns/layouts/auth/AuthLayout.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';

export function SSODisabled() {
  return (
    <AuthLayout>
      <CenteredLayout className="pad-0" preventNotifications={true}>
        <div role="alert">
          <h2 className="h3 mb-8">SSO is not enabled</h2>
          <p className="p mb-24">
            Please contact your company’s Defined Networking administrator if this is unexpected, or log in with your
            email and TOTP.
          </p>
          <LinkButton to="/" variant="secondary">
            Log in
          </LinkButton>
        </div>
      </CenteredLayout>
    </AuthLayout>
  );
}
